import { useEffect, useState } from 'react';

export function useLoopingCountdown(totalSeconds: number) {
  const [remaining, setRemaining] = useState(totalSeconds);

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((r) => (r <= 1 ? totalSeconds : r - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, [totalSeconds]);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  return { hours, minutes, seconds };
}
